// Simple error tracking implementation
class ErrorTracker {
  private static instance: ErrorTracker;
  private isInitialized = false;

  private constructor() {
    if (!this.isInitialized) {
      this.initialize();
      this.isInitialized = true;
    }
  }

  public static getInstance(): ErrorTracker {
    if (!ErrorTracker.instance) {
      ErrorTracker.instance = new ErrorTracker();
    }
    return ErrorTracker.instance;
  }

  private initialize() {
    window.addEventListener('error', this.handleError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  private handleError = (event: ErrorEvent) => {
    console.error('Error:', event.error);
  };

  private handleUnhandledRejection = (event: PromiseRejectionEvent) => {
    console.error('Unhandled Promise Rejection:', event.reason);
  };
}

export const errorTracker = ErrorTracker.getInstance();